import {cashBoxRegister} from "../../../hoc/cashBoxRegister";

const CashBoxCashInEdit = cashBoxRegister("CashBoxCashInEdit")

export default CashBoxCashInEdit
